export default {"src":"/_next/static/image/public/images/icons/phone-icon.d3966881c141fa8a53619e48479f5d24.svg","height":20,"width":20};